export const Global: any =  {
    homePage: 'homePage',
    contactPage: 'contactPage',
    blogPage: 'blogPage'
}